import { useAuth0 } from '@auth0/auth0-react';
import { auth0Locales } from '../../i18n';
import { useLanguage } from '../../i18n/LanguageProvider';

export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  const { language } = useLanguage();

  return (
    <button
      onClick={() =>
        loginWithRedirect({
          authorizationParams: { ui_locales: auth0Locales[language] },
        })
      }
    >
      Log In
    </button>
  );
};
